(function() {
    'use strict';

    angular
        .module('telestatApp')
        /*
         * Фильтр используется в phone-calls.html, phone-call-dialog.html
         * позволяет загрузку phoneCall.recordURL (mp3) с внешнего ресурса.
         */
        .filter('trusted', ['$sce', function ($sce) {
            return function(url) {
                return $sce.trustAsResourceUrl(url);
            };
        }])
        .filter('MMss', function () {
            return function (sec) {
                if (sec == null) {
                    return '-';
                }
                var sec_num = parseInt(sec, 10);
                var minutes = Math.floor(sec_num / 60);
                var seconds = sec_num - minutes * 60;
                if (minutes < 10) {minutes = "0" + minutes;}
                if (seconds < 10) {seconds = "0" + seconds;}
                return minutes + ':' + seconds;
            };
        });
})();
